// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1tOly","label":"LabeledBox_label__28M8M"};